<template>
    <v-tooltip
        :disabled="!desabilitarEnvio"
        top
    >
      <a slot="activator">
        <v-btn
            id="botaoEnviarDocumentos"
            color="primary"
            @click="$emit('enviar')"
            :disabled="desabilitarEnvio"
            outline
            flat>
          Enviar Documentos
        </v-btn>
      </a>
      Os documentos foram enviados. Para alterar é necessário aguardar que solicitem o reenvio.
    </v-tooltip>
</template>

<script>
export default {
    name: 'botaoEnviarDocumentos',
    props:{
        desabilitarEnvio: {
            type: Boolean
        }
    }
}
</script>

<style scoped lang="stylus">
  .botao-enviar-anexos
    text-align right
</style>